var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmileyMeh = function SvgSmileyMeh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 35c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15Z",
    stroke: "currentColor",
    strokeWidth: 2.469,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 25h12.5",
    stroke: "currentColor",
    strokeWidth: 2.469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 18.75a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75ZM26.125 18.75a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z",
    fill: "currentColor"
  })));
};
export default SvgSmileyMeh;